<template>
  <ValidationObserver ref="salary">
    <div class="salary">
      <div>
        <h2 class="mb-5">
          What’s the minimum salary you are expecting?
        </h2>
      </div>
      <div>
        <ValidationProvider v-slot="{ errors }" rules="required|minNumber:0">
          <v-text-field
            :min="0"
            aria-label="Minimum salary preference"
            type="number"
            prepend-inner-icon="mdi-currency-gbp"
            class="text-field"
            :error-messages="errors"
            :disabled="isLoading"
            v-model="minimumSalaryPreference"
          />
        </ValidationProvider>
        <p class="font-italic mt-2 salary-info">
          Equivalent to approximately £{{
            (minimumSalaryPreference / 2000).toFixed(2)
          }}
          per hour (assuming 40 hours per week)
        </p>
      </div>
      <div class="d-flex justify-end">
        <PrimaryButton @click.native="nextStep" :loading="isLoading">
          {{ isEditMode ? "Save Changes" : "Create Profile" }}
        </PrimaryButton>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { EDIT_USER } from "@/store/modules/users/actions";
import {
  getAmountInApiFormat,
  getAmountInDisplayFormat
} from "@/utils/helpers";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const { mapActions } = createNamespacedHelpers(USERS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "Salary",
  components: {
    PrimaryButton,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    userId: String,
    isEditMode: Boolean
  },
  data() {
    return {
      isLoading: false,
      minimumSalaryPreference: null
    };
  },
  created() {
    this.minimumSalaryPreference = getAmountInDisplayFormat(
      this.userData.minimumSalaryPreference
    );
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      editUser: EDIT_USER
    }),
    async nextStep() {
      const isValid = await this.$refs.salary.validate();
      if (isValid) {
        this.$emit("nextStep");
      }
    },
    async handleUpload() {
      if (this.minimumSalaryPreference || !this.isEditMode) {
        this.isLoading = true;
        await this.editUser({
          id: this.userId,
          data: {
            ...(this.minimumSalaryPreference && {
              minimumSalaryPreference: getAmountInApiFormat(
                this.minimumSalaryPreference
              ),
              in_talent_pool: true
            })
          }
        });
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.salary .salary-info {
  font-size: 16px;
}
</style>
